import * as actionType from './actions/pmpActions';

const initialState = {
    list: [],
    message: '',
    modalOpen: false,
    loading: false,
    isPMPEdit: false,
    isPMPList: true,
    apiStatus: false
}

const pmpReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_PMP_LIST:
            return { ...state, loading: false, modalOpen: false, isPMPList: true, isPMPEdit: false, isAssetCreate: false, message: "", PMPDetails: action.payload }
        case actionType.GET_TECHNICIAN_LIST:
            return { ...state, modalOpen: false, isPMPList: true, isPMPEdit: false, isAssetCreate: false, message: "", TechnicianDetails: action.payload }
        case actionType.API_CALL_STATUS:
            return { ...state, loading: action.payload.loading,apiStatus:action.payload.apiStatus, modalOpen: action.payload.modalOpen, message: action.payload.message}
        case actionType.POST_PMP_DATA:
            return{...state,loading:action.payload.loading, apiStatus:action.payload.apiStatus,modalOpen:action.payload.modalOpen, message:action.payload.message}
        case actionType.IS_PMP_PLANNER:
            return { ...state, modalOpen: false, loading: false,isPMPEdit:false,isPMPList:action.payload, message:'' }          
        case actionType.SELECTED_DATA_INFO:
            return{...state,modalOpen: false, loading: false,isPMPEdit:false, SelectedDataInfo:action.payload}
        case actionType.GET_PMP_REPORT_DATA:
            return{...state,isPMPEdit:false, PMPReportData:action.payload}
        case actionType.GET_WORKREQUEST_REPORT_DATA:
            return{...state,isPMPEdit:false, WorkRequestReportData:action.payload}
        case actionType.CLEAR_DATA:
            return{...state,modalOpen: false, loading: false,isPMPEdit:false, PMPReportData:[],WorkRequestReportData:[],message:""}
        default:
            return state
    }
}

export default pmpReducer;